import { useEffect } from 'react';
import { CRM_SUITE_ENTERPRISE_BUNDLE, CRM_SUITE_PROFESSIONAL_BUNDLE, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { SALES } from 'self-service-api/constants/ProductLines';
import { MC_0673_GROUP_PARAMETER_KEY, MC_0673_GROUP_PARAMETER_OPTIONS, MC_0673_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = MC_0673_TREATMENT_KEY;
const groupParameterKey = MC_0673_GROUP_PARAMETER_KEY;
const groupParameterOptions = MC_0673_GROUP_PARAMETER_OPTIONS;
export const logMC0673Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};
export const useMC0673Experiment = productLine => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, treatmentKey));
  const areExperimentsLoading = useAppSelector(areExperimentsLoadingSelector);
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isAppReady = useGlobalLoading();
  const ownedProducts = useAppSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const ownsSalesProOrSalesEnt = ownedProducts.some(product => product.apiName === SALES_HUB_PROFESSIONAL || product.apiName === SALES_HUB_ENTERPRISE || product.apiName === CRM_SUITE_PROFESSIONAL_BUNDLE || product.apiName === CRM_SUITE_ENTERPRISE_BUNDLE);
  const isEligible = hasExperimentsFetchSucceeded && productLine === SALES && !isAcceptanceTest && isAppAuth && !ownsSalesProOrSalesEnt;
  const isControl = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === (groupParameterOptions === null || groupParameterOptions === void 0 ? void 0 : groupParameterOptions.control);
  const isVariant = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === (groupParameterOptions === null || groupParameterOptions === void 0 ? void 0 : groupParameterOptions.variation);
  return {
    isEligibleForMC0673: isEligible,
    isMC0673Control: isControl,
    isMC0673Variation: isVariant,
    isMC0673Fetched: hasExperimentsFetchSucceeded,
    // isAppReady is checked to prevent logging exposures before owned products are loaded
    isMC0673Loading: areExperimentsLoading || !isAppReady
  };
};

// Hook for logging exposure and returning experiment data
export const useMC0673ExperimentAndLogExposure = productLine => {
  const experiment = useMC0673Experiment(productLine);
  useEffect(() => {
    if (experiment.isEligibleForMC0673 && !experiment.isMC0673Loading) {
      logMC0673Exposure();
    }
  }, [experiment.isEligibleForMC0673, experiment.isMC0673Loading]);
  return experiment;
};